import axios from "axios";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Config } from "../../../../../Config";
import { formatDate } from "../../../../../Helper_functions";
import IconSwitch from "../../ShareElements/Switch/IconSwitch";
import DeleteJPAmodal from "./DeleteJPAmodal";

const JPAItem = (props) => {
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const displayTitle = () => {
    if (props.IsJob) {
      return props.JPA.position.title;
    } else if (props.IsProject) {
      return props.JPA.project.title;
    } else if (props.IsActivity) {
      return props.JPA.activity.title;
    }
  };

  const displayLocation = () => {
    if (props.IsJob) {
      return props.JPA.position.workCity !== null
        ? props.JPA.position.workCity
        : "";
    } else if (props.IsProject) {
      return props.JPA.project.workCity !== null
        ? props.JPA.project.workCity
        : "";
    } else if (props.IsActivity) {
      return props.JPA.activity.workCity !== null
        ? props.JPA.activity.workCity
        : "";
    }
  };

  const displayDesctiption = () => {
    if (props.IsJob) {
      let Desc = props.JPA.position.description;
      if (Desc === undefined || Desc === null) {
        return "";
      } else if (Desc.length < 83) {
        return Desc;
      } else {
        return Desc.slice(0, 83) + " ...";
      }
    } else if (props.IsProject) {
      let Desc = props.JPA.project.description;
      if (Desc === undefined || Desc === null) {
        return "";
      } else if (Desc.length < 83) {
        return Desc;
      } else {
        return Desc.slice(0, 83) + " ...";
      }
    } else if (props.IsActivity) {
      let Desc = props.JPA.activity.description;
      if (Desc === undefined || Desc === null) {
        return "";
      } else if (Desc.length < 83) {
        return Desc;
      } else {
        return Desc.slice(0, 83) + " ...";
      }
    }
  };

  const displayDate = () => {
    if (props.IsJob) {
      return formatDate(new Date(props.JPA.position.startDate).getTime());
    } else if (props.IsProject) {
      return formatDate(new Date(props.JPA.project.startDate).getTime());
    } else if (props.IsActivity) {
      return formatDate(new Date(props.JPA.activity.startDate).getTime());
    }
  };

  const selectJPA = () => {
    if (props.IsJob) {
      return props.JPA.position;
    } else if (props.IsProject) {
      return props.JPA.project;
    } else if (props.IsActivity) {
      return props.JPA.activity;
    }
  };

  const confirmDelete = () => {
    let ReqURL;
    let Data = {};
    if (props.IsJob) {
      Data.positionId = props.JPA.position.id;
      ReqURL = Config.PositionServiceURL + "/api/position/preset/remove-preset";
    } else if (props.IsProject) {
      Data.projectId = props.JPA.project.id;
      ReqURL = Config.ProjectServiceURL + "/api/project/preset/remove-preset";
    } else if (props.IsActivity) {
      Data.activityId = props.JPA.activity.id;
      ReqURL = Config.ActivityServiceURL + "/api/activity/preset/remove-preset";
    }
    let Req = {
      method: "DELETE",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.RefreshData();
        setDeleteIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleCandidates = () => {
    if (props.IsJob) {
      window.localStorage.setItem("CreatedJPAId", props.JPA.position.id);
      document.getElementById("job-candidates-link").click();
    } else if (props.IsProject) {
      window.localStorage.setItem("CreatedJPAId", props.JPA.project.id);
      document.getElementById("project-candidates-link").click();
    } else if (props.IsActivity) {
      window.localStorage.setItem("CreatedJPAId", props.JPA.activity.id);
      document.getElementById("activity-candidates-link").click();
    }
  };

  const displayStatus = () => {
    let Status;
    if (props.IsJob) {
      Status = props.JPA.position.recruitmentStatus;
    } else if (props.IsProject) {
      Status = props.JPA.project.recruitmentStatus;
    } else if (props.IsActivity) {
      Status = props.JPA.activity.recruitmentStatus;
    }
    if (Status === "IN_PROGRESS") {
      return (
        <span className="status-label" style={{ backgroundColor: "#D9B16C" }}>
          {translateText("in_progress")}
        </span>
      );
    } else if (Status === "POPULAR") {
      return (
        <span className="status-label" style={{ backgroundColor: "#A781E3" }}>
          {translateText("popular")}
        </span>
      );
    } else if (Status === "ACCEPTED") {
      return (
        <span className="status-label" style={{ backgroundColor: "#71D9BB" }}>
          {translateText("jpa_status_accepted")}
        </span>
      );
    } else if (Status === "NEW") {
      return (
        <span className="status-label" style={{ backgroundColor: "#6DA2F2" }}>
          {translateText("new")}
        </span>
      );
    } else if (Status === null) {
      return (
        <span className="status-label" style={{ backgroundColor: "#DE8C8C" }}>
          {translateText("not_started")}
        </span>
      );
    }
  };

  const togglePublish = () => {
    let Action;
    if (
      document
        .getElementById(props.JPA.id + "-icon-switch")
        .classList.contains("icon-switch-wrapper-active")
    ) {
      Action = "PUBLISH";
    } else {
      Action = "UNPUBLISH";
    }
    let ReqURL;
    let Id;
    if (props.IsJob) {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/publish-unpublish";
      Id = props.JPA.position.id;
    } else if (props.IsProject) {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/publish-unpublish";
      Id = props.JPA.project.id;
    } else if (props.IsActivity) {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/publish-unpublish";
      Id = props.JPA.activity.id;
    }
    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: Id,
        action: Action,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <div className="jpa-item">
      <NavLink
        hidden
        to="/vacancyCandidates"
        id="job-candidates-link"
      ></NavLink>
      <NavLink
        hidden
        to="/projectCandidates"
        id="project-candidates-link"
      ></NavLink>
      <NavLink
        hidden
        to="/activityCandidates"
        id="activity-candidates-link"
      ></NavLink>
      {DeleteIsOpen ? (
        <DeleteJPAmodal
          LangData={props.LangData}
          Close={() => setDeleteIsOpen(false)}
          Confirm={() => confirmDelete()}
          JPAItem={selectJPA()}
        />
      ) : null}
      <span className="trash" onClick={() => setDeleteIsOpen(true)}></span>
      <div className="status-holder">{displayStatus()}</div>
      <div className="publish-switch">
        <IconSwitch
          IsActive={props.JPA.published}
          Id={props.JPA.id}
          ChangeEvent={() => togglePublish()}
        />
      </div>
      <section className="jpa-item-head">
        <h1 className="jpa-title">{displayTitle()}</h1>
        <p className="jpa-location">{displayLocation()}</p>
      </section>
      <section className="jpa-description">{displayDesctiption()}</section>
      <section className="jpa-item-date">
        <p className="date-label">
          <i className="feather-calendar"></i>
          {translateText("start_date")}
        </p>
        <p className="jpa-date">{displayDate()}</p>
      </section>
      <section className="jpa-item-actions">
        <span className="action candidates" onClick={() => toggleCandidates()}>
          {translateText("candidates")}
        </span>
      </section>
    </div>
  );
};

export default JPAItem;
